import React from 'react';
import { isAllergen } from '../../../Utils/Helpers';
import { useTranslation } from 'react-i18next';
import Badge from '../Badge';

interface BadgeAllergenTagProps {
    product: any;
    outline?: boolean;
    className?: string;
}

const BadgeAllergenTag = ({
    product,
    outline = false,
    className,
}: BadgeAllergenTagProps) => {

    const { t } = useTranslation();

    if (!product) return null;

    if (isAllergen(product)) {
        return (
            <div className={`flex items-center justify-center ${className}`}>
                <Badge outline={outline} type="allergen" className="normal-case text-xs rounded-full">
                    {t('products.badges.allergen_label')}
                </Badge>
            </div>
        );
    }
    return null;
};

export default BadgeAllergenTag;
